"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var value_checker_1 = __importDefault(require("../validation/value_checker"));
var object_utils_1 = __importDefault(require("./object_utils"));
var SalesForceAccountObject = /** @class */ (function () {
    function SalesForceAccountObject() {
    }
    SalesForceAccountObject.create = function (contractDocument, salesForceInfo) {
        var baseObject;
        if (value_checker_1.default.isBlank(contractDocument.requestInfoIsReadOnly)) {
            baseObject = {
                JigNo__c: contractDocument.officeInfoOfficeNo,
                HojinName__c: contractDocument.officeInfoCompanyName,
                HojinNameKana__c: contractDocument.officeInfoCompanyNameKana,
                Name: contractDocument.officeInfoOfficeName,
                NameKana__c: contractDocument.officeInfoOfficeNameKana,
                BillingPostalCode: contractDocument.officeInfoZip1 + "-" + contractDocument.officeInfoZip2,
                BillingState: contractDocument.officeInfoAddress1,
                BillingCity: contractDocument.officeInfoAddress2,
                BillingStreet: contractDocument.officeInfoAddress3,
                CareOfficePhone__c: contractDocument.officeInfoTel,
                BillHojinName__c: contractDocument.requestInfoCompanyName,
                BillTell__c: contractDocument.requestInfoTel,
                ShippingPostalCode: contractDocument.requestInfoZip1 + "-" + contractDocument.requestInfoZip2,
                ShippingState: contractDocument.requestInfoAddress1,
                ShippingCity: contractDocument.requestInfoAddress2,
                ShippingStreet: contractDocument.requestInfoAddress3,
                BillPerson__c: contractDocument.requestInfoRequestPersonLastName + " " + contractDocument.requestInfoRequestPersonFirstName,
                BillMail__c: contractDocument.requestInfoRequestEmail,
                BillWay__c: object_utils_1.default.getSalesForceHowToApply(contractDocument.requestInfoHowToRequest),
                BillJigName__c: contractDocument.requestInfoOfficeName,
                NotificationWay__c: contractDocument.requestInfoHowToSend,
                CareOfficeEmail__c: contractDocument.officeInfoTantosyaMail
            };
        }
        else {
            baseObject = {
                JigNo__c: contractDocument.officeInfoOfficeNo,
                HojinName__c: contractDocument.officeInfoCompanyName,
                HojinNameKana__c: contractDocument.officeInfoCompanyNameKana,
                Name: contractDocument.officeInfoOfficeName,
                NameKana__c: contractDocument.officeInfoOfficeNameKana,
                BillingPostalCode: contractDocument.officeInfoZip1 + "-" + contractDocument.officeInfoZip2,
                BillingState: contractDocument.officeInfoAddress1,
                BillingCity: contractDocument.officeInfoAddress2,
                BillingStreet: contractDocument.officeInfoAddress3,
                CareOfficePhone__c: contractDocument.officeInfoTel,
                CareOfficeEmail__c: contractDocument.officeInfoTantosyaMail
            };
        }
        if (value_checker_1.default.isPresent(salesForceInfo.torihikisakiId)) {
            baseObject['Id'] = salesForceInfo.torihikisakiId;
        }
        else {
            baseObject['OwnerId'] = salesForceInfo.lastUpdateUser;
        }
        return baseObject;
    };
    return SalesForceAccountObject;
}());
exports.default = SalesForceAccountObject;



//////////////////
// WEBPACK FOOTER
// ./common/src/utils/sales_force/account_object.ts
// module id = +7dT
// module chunks = 1